import { Validator } from "../Base";

export default abstract class BaseValidator implements Validator {
    private validationName: string;

    private validationMessage: string;

    constructor(name: string, message: string) {
        this.validationName = name;
        this.validationMessage = message;
    }

    abstract isNotValid(value: any): boolean;

    get message(): string {
        return this.validationMessage;
    }

    get name(): string {
        return this.validationName;
    }
}
